import React, { useEffect, useState, useRef } from 'react';
import { useLoader } from '../../../common/Context/LoaderContext';
import { useAlert } from '../../../common/Context/AlertContext';
import { useAuth } from '../../../common/Context/AuthContext';
import { useProductData } from '../../../common/functions/userProductData/UserProductData';
import TryNow from '../tryNow/TryNow';
import CategorySidebar from './CategorySidebar';
import ProductGrid from './ProductGrid';
import TryNowHeader from './TryNowHeader';
import OurProductsListing from './OurProductsListing';
import SearchField from './SearchField';
import CategoryToggleButton from '../../categoryToggleButton/CategoryToggleButton';
import EmptyState from '../../emptyState/EmptyState';

function OurProducts() {
  const { showAlert } = useAlert();
  const { setLoading } = useLoader();
  const { user, logout } = useAuth();
  const [searchTerm, setSearchTerm] = useState('');
  const [showSidebar, setShowSidebar] = useState(false);
  const productContainerRef = useRef(null);
  const { products, subproductscategory, selectedCategory } = useProductData(
    showAlert,
    setLoading
  );

  const toggleSidebar = () => {
    setShowSidebar((prev) => !prev);
  };

  const [tryNowProduct, setTryNowProduct] = useState(null);

  // Filtered products based on search
  const filteredProducts = products.filter(
    (product) =>
      product.productTitle?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      product.productSubTitle?.toLowerCase().includes(searchTerm.toLowerCase())
  );
  // Listen for hash changes to support back/forward navigation and restore category
  useEffect(() => {
    const onHashChange = () => {
      const hash = window.location.hash;
      let productId = null;
      let categoryFromHash = null;
      if (hash.startsWith('#/try/')) {
        const hashParts = hash.replace('#/try/', '').split('?');
        productId = hashParts[0];
        if (hashParts[1]) {
          const params = new URLSearchParams(hashParts[1]);
          categoryFromHash = params.get('category');
        }
        const found = products.find(
          (p) => String(p.productId) === String(productId)
        );
        setTryNowProduct(found || null);
      } else {
        setTryNowProduct(null);
      }
    };
    window.addEventListener('hashchange', onHashChange);
    // Initial check
    onHashChange();
    return () => window.removeEventListener('hashchange', onHashChange);
  }, [products]);

  // Handler for category selection
  const handleCategorySelect = (categoryName) => {
    setShowSidebar(false);
    window.location.hash = `#?category=${encodeURIComponent(categoryName)}`;
  };

  // Handler for Try Now click
  const handleTryNow = (product) => {
    window.location.hash = `#/try/${
      product.productId
    }?category=${encodeURIComponent(selectedCategory)}`;
  };

  // Handler for Try Now back
  const handleTryNowBack = () => {
    const hash = window.location.hash;
    let categoryQuery = '';
    if (hash.startsWith('#/try/')) {
      const hashParts = hash.replace('#/try/', '').split('?');
      if (hashParts[1]) {
        categoryQuery = '?' + hashParts[1];
      }
    }
    window.location.hash = categoryQuery;
    setTryNowProduct(null);

    // Scroll to top when going back to product list
    setTimeout(() => {
      if (productContainerRef.current) {
        productContainerRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }, 100);
  };

  return (
    <>
      <div className="container">
        <div className="py-3 ">
          {/* //userOnlyShowComponent */}
          {user ? (
            <>
              {/* <TrylayoutBanner /> */}
              <div className="position-relative ProductLayoutMain row mt-0">
                {!tryNowProduct && (
                  <CategorySidebar
                    categories={subproductscategory}
                    selectedCategory={selectedCategory}
                    onCategorySelect={handleCategorySelect}
                    isActive={showSidebar}
                    toggleSidebar={toggleSidebar}
                  />
                )}
                <div
                  className={`${
                    tryNowProduct ? 'col-12' : 'col-lg-8 col-xl-9 '
                  }`}
                >
                  {tryNowProduct ? (
                    <>
                      <div
                        className="bg-white br_10 "
                        ref={productContainerRef}
                      >
                        <div className="d-flex pt-3 px-3 justify-content-between align-items-start align-items-md-center mb-3 mb-lg-0">
                          <TryNowHeader
                            productName={tryNowProduct.productName}
                            onBack={handleTryNowBack}
                          />
                          <CategoryToggleButton
                            showSidebar={showSidebar}
                            toggleSidebar={toggleSidebar}
                          />
                        </div>
                        <TryNow productId={tryNowProduct?.productId} />
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="h-100 d-flex flex-column justify-content-between bg-white p-3 br_10 ">
                        <div className="mb-3 d-lg-flex align-items-center justify-content-between">
                          <h3 className="font_20 mb-2 mb-lg-0">
                            Featured Products
                          </h3>
                          <div className="d-flex d-lg-flex align-items-center gap-2">
                            <SearchField
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <CategoryToggleButton
                              showSidebar={showSidebar}
                              toggleSidebar={toggleSidebar}
                            />
                          </div>
                        </div>
                        {filteredProducts.length === 0 ? (
                          <EmptyState
                            style={{ marginTop: 100 }}
                            description="Nothing to display"
                          />
                        ) : (
                          <ProductGrid
                            products={filteredProducts}
                            selectedCategory={selectedCategory}
                            onTryNow={handleTryNow}
                          />
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </>
          ) : (
            <>
              <OurProductsListing
                products={products}
                subproductscategory={subproductscategory}
                selectedCategory={selectedCategory}
              />
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default OurProducts;
